export default __webpack_public_path__ + "static/media/Shot_12.0000.7a92b6fa.png";